// ============================================================
// FILE: src/components/Marquee.jsx  →  SCROLLING WORDS STRIP
// The slow-scrolling big outlined words on the homepage.
// The words are in src/data/site.js (SCROLLING MARQUEE WORDS).
// "speed={28}" below = scrolling speed (higher = faster).
// ============================================================

import Marquee from "react-fast-marquee";
import { Globe2 } from "lucide-react";

export default function EditorialMarquee({ items, className = "" }) {
  return (
    <div className={`relative border-y border-slate-900/10 py-7 dark:border-white/10 ${className}`} data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-display text-4xl font-bold uppercase tracking-tight outline-text sm:text-5xl">
              {item}
            </span>
            <Globe2 className="h-6 w-6 text-teal-500/60" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
